export const htmlString = "<!-- import {ViewModel as ViewModel} from './widget' -->\n<div class=\"@@ @@@\">\n    <div data-marker=\"code\" />\n</div>";